












import {Component, Vue} from 'vue-property-decorator'
import AppFooter from '@/components/footer/AppFooter.vue'
import Navbar from '@/components/navbar/Navbar.vue'
import {MetaInfo} from 'vue-meta'
import PrivacyPolicyHeader from '@/components/privacyPolicy/PrivacyPolicyHeader.vue'
import PrivacyPolicyContent from '@/components/privacyPolicy/PrivacyPolicyContent.vue'

@Component({
  components: {
    AppFooter,
    Navbar,
    PrivacyPolicyHeader,
    PrivacyPolicyContent,
  },
})
export default class PrivacyPolicyView extends Vue {
  metaInfo(): MetaInfo {
    return {
      title: this.$translate('metadata.title.privacyPolicy'),
    }
  }

  mounted() {
    window.scrollTo(0, 0)
  }
}
